module.exports = __webpack_public_path__ + "officialStatic/img/plus-icon2.7d4e288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/plus-icon2.png
// module id = 3fC0
// module chunks = 0